import { useState } from "react";
import { useQueryClient, type QueryClient } from "@tanstack/react-query";
import { setUser } from "@sentry/react";

export async function signOut(client: QueryClient, redirect = () => window.location.assign("/")) {
  const response = await fetch("/api/auth/logout", { method: "POST" });
  if (!response.ok) throw new Error("logout_failed");
  await client.cancelQueries();
  client.clear();
  sessionStorage.removeItem("reading-return");
  setUser(null);
  redirect();
}

export function useSignOut() {
  const client = useQueryClient();
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  async function logout() {
    setPending(true);
    setError("");
    try { await signOut(client); }
    catch { setError("לא הצלחנו להתנתק. נסו שוב."); setPending(false); }
  }
  return { logout, error, pending };
}
